
import { ShoppingBag, Clock } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";

interface PublicMenuTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  children?: React.ReactNode;
}

export function PublicMenuTabs({ 
  activeTab, 
  setActiveTab,
  children
}: PublicMenuTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="mb-6">
      <TabsList className="w-full grid grid-cols-2">
        <TabsTrigger value="menu" className="flex items-center gap-2">
          <ShoppingBag className="h-4 w-4" />
          {t("menu")}
        </TabsTrigger>
        <TabsTrigger value="order" className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          {t("currentOrder")}
        </TabsTrigger>
      </TabsList>
      
      {children}
    </Tabs>
  );
}
